import { createApiClient } from '@delta/api-client';

// Tenant discovery and branding must work even when a saved login has expired.
export const publicApi = createApiClient({ baseURL: '/api' });
